import { createResourceStore } from "@/lib/resource";

export interface OhadaCode {
  id: string;
  code: string;
  title: string;
  description?: string | null;
  type?: string | null;
  classification: string;
  subclass?: string | null;
}

export const useOhadaCode = createResourceStore<OhadaCode>("ohada-codes");
